module.exports = __webpack_public_path__ + "static/media/JeffMan.75d1a0aa.jpg";